// extracted by mini-css-extract-plugin
export default {"tooltip":"ToolTip_tooltip__ZDXce"};